define('ui/search-specref',["exports", "core/ui", "core/biblio", "core/l10n"], function (exports, _ui, _biblio, _l10n) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.show = undefined;


  const button = _ui.ui.addCommand(_l10n.l10n[_l10n.lang].search_specref, "ui/search-specref", "Ctrl+Shift+Alt+space", "🔎"); // Module ui/search-specref
  // Search Specref database

  const specrefURL = "https://specref.herokuapp.com/";
  const refSearchURL = `${specrefURL}search-refs`;
  const reveseLookupURL = `${specrefURL}reverse-lookup`;
  const form = document.createElement("form");
  const renderer = window.hyperHTML.bind(form);
  const resultList = hyperHTML.bind(document.createElement("div"));

  form.id = "specref-ui";

  function renderResults(resultMap, query, timeTaken) {
    if (!resultMap.size) {
      return resultList`
      <p class="state">
        Your search - <strong> ${query} </strong> -
        did not match any references.
      </p>
    `;
    }
    const wires = Array.from(resultMap.entries()).slice(0, 99).map(toDefinitionPair).reduce((collector, pair) => collector.concat(pair), []);
    return resultList`
    <p class="result-stats">
      ${resultMap.size} results (${timeTaken} seconds).
      ${resultMap.size > 99 ? "First 100 results." : ""}
    </p>
    <dl class="specref-results">${wires}</dl>
  `;
  }

  function toDefinitionPair([key, entry]) {
    return hyperHTML.wire(entry)`
    <dt>
      [${key}]
    </dt>
    <dd>${(0, _biblio.wireReference)(entry)}</dd>
  `;
  }

  function resultProcessor({ includeVersions } = { includeVersions: false }) {
    return (...fetchedData) => {
      const combinedResults = fetchedData.reduce((collector, resultObj) => Object.assign(collector, resultObj), {});
      const results = new Map(Object.entries(combinedResults));
      // remove aliases
      Array.from(results.entries()).filter(([, entry]) => entry.aliasOf).map(([key]) => key).reduce((results, key) => results.delete(key) && results, results);
      // Remove versions, if asked to
      if (!includeVersions) {
        Array.from(results.values()).filter(entry => typeof entry === "object" && "versions" in entry).reduce((collector, entry) => collector.concat(entry.versions), []).forEach(version => {
          results.delete(version);
        });
      }
      // Remove legacy string entries
      Array.from(results.entries()).filter(([, entry]) => typeof entry !== "object").reduce((result, [key]) => results.delete(key) && results, results);
      return results;
    };
  }

  form.addEventListener("submit", async ev => {
    ev.preventDefault();
    const { searchBox } = form;
    const query = searchBox.value;
    if (!query) {
      searchBox.focus();
      return;
    }
    render({ state: "Searching Specref…" });
    const refSearch = new URL(refSearchURL);
    refSearch.searchParams.set("q", query);
    const reverseLookup = new URL(reveseLookupURL);
    reverseLookup.searchParams.set("urls", query);
    try {
      const startTime = performance.now();
      const jsonData = await Promise.all([fetch(refSearch).then(response => response.json()), fetch(reverseLookup).then(response => response.json())]);
      const { checked: includeVersions } = form.includeVersions;
      const processResults = resultProcessor({ includeVersions });
      const results = processResults(...jsonData);
      render({
        query,
        results,
        state: "",
        timeTaken: Math.round(performance.now() - startTime) / 1000
      });
    } catch (err) {
      console.error(err);
      render({ state: "Error! Couldn't do search." });
    } finally {
      searchBox.focus();
    }
  });

  function show() {
    render();
    _ui.ui.freshModal(_l10n.l10n[_l10n.lang].search_specref, form, button);
    form.querySelector("input[type=search]").focus();
  }

  const mast = hyperHTML.wire()`
  <header>
    <p>
      An Open-Source, Community-Maintained Database of
      Web Standards & Related References.
    </p>
  </header>
  <div class="searchcomponent">
    <input
      name="searchBox"
      type="search"
      autocomplete="off"
      placeholder="Keywords, titles, authors, urls…">
    <button
      type="submit">
        Search
    </button>
    <label>
      <input type="checkbox" name="includeVersions"> Include all versions.
    </label>
  </div>
`;

  function render({ state, results, timeTaken, query } = { state: "" }) {
    if (!results) {
      renderer`<div>${mast}</div>`;
      return;
    }
    renderer`
    <div>${mast}</div>
    <p class="state" hidden="${!state}">
      ${state}
    </p>
    <section hidden="${!results}">${results ? renderResults(results, query, timeTaken) : []}</section>
  `;
  }

  exports.show = show;
});
//# sourceMappingURL=search-specref.js.map;
